export const numberAsStringComparator = (value1: string, value2: string) => {
    return Number(value1) > Number(value2) ? 1 : -1;
};
